const surfaceConfigs = {
    home: {
        querySource: 'home',
        analyticsSurface: 'ask-input',
        reason: 'home-ask-input',
        searchModeSelectedEventName: 'homepage search mode selected',
        autosuggestEnabled: true,
        externalValueCaret: 'end',
        mobileOverlayEnabled: true,
        floatWhileCommandMenuOpen: false,
        upsellSurface: 'homepage',
        projectSearchSource: 'homepage',
    },
    sessions: {
        querySource: 'sessions',
        analyticsSurface: 'sessions-composer',
        reason: 'sessions-composer',
        searchModeSelectedEventName: 'sessions composer search mode selected',
        autosuggestEnabled: false,
        externalValueCaret: 'preserve',
        mobileOverlayEnabled: false,
        floatWhileCommandMenuOpen: true,
        upsellSurface: 'sessions',
        projectSearchSource: 'sessions',
    },
};
export function getAskComposerSurfaceConfig(surface) {
    return surfaceConfigs[surface];
}
//# sourceMappingURL=surfaceConfig.js.map